import React, { useEffect, useState } from 'react';
import { Box, Container, List, ListItem, ListItemText, Typography } from '@mui/material';
import powerplatform from '../assets/Images/services/power-platform.png';
import copilot from '../assets/Images/services/copilot.jpg';

import CustomerStories from './CustomerStories';
import { workCaseStudy } from '../interface/WorkCaseStudy';
import workJson from "../Work.json";
import Footer from '../components/Footer';
import { serviceWorkFilter } from '../common-functions/serviceWorkFilter';
import { CardData, TabData } from '../interface/TabData';
import ServiceTabbingSection from '../sub-sections/ServiceCommonComponent/ServiceTabbingSection';
import ServiceCardSection from '../sub-sections/ServiceCommonComponent/ServiceCardSection';
import CaseStudyLetsGetStarted from '../sub-sections/CaseStudy/CaseStudyLetsGetStarted';
import useMetaTags from '../common-functions/useMetaTags';

const MsCopilotSection: React.FC = () => {
    useMetaTags(
        "Microsoft Copilot | AI-Powered Productivity & Insights",
        "Enhance productivity and gain actionable insights with Microsoft Copilot. Transform workflows, streamline decision-making, and unlock new possibilities using AI-driven solutions tailored to your needs.",
        "AI-powered productivity tools, Microsoft Copilot integration, workflow automation, actionable insights, seamless collaboration, intelligent decision-making, secure AI solutions, Copilot for businesses"
    );    
    const tabData: TabData[] = [
        {
            heading: (<>GitHub <br></br>Copilot</>),
            imgSrc: `
            <img class="animation-img-class animation-delay300 disnone img-responsive wow fadeInDown animated fadeinScroll" 
            src="/assets/Images/cloud/GithubCopilot.png" alt="compute-services" data-wow-duration="1500ms" data-wow-delay="300ms" 
            style="display: block;">`,
            content: (<>
                <p>Unlock the power of AI-driven development with GitHub Copilot. Our experts help businesses integrate Copilot into their development workflows, enabling faster coding, enhanced productivity, and intelligent code suggestions tailored to your needs.</p>
                <p>Whether you're building enterprise applications or scaling your development team, we provide consultation, implementation, and training to ensure seamless adoption of GitHub Copilot.</p>
                <p>Explore our works. <a href="/work" onClick={() => selectedTechnology()} className="underlineancor">Discover our case studies.</a></p>
            </>),
        },
        {
            heading: (<>Microsoft 365 <br></br>Copilot</>),
            imgSrc: `
            <img class="animation-img-class animation-delay300 disnone img-responsive wow fadeInDown animated fadeinScroll" 
            src="/assets/Images/cloud/office365Copilot.png" alt="storage-services" data-wow-duration="1500ms" data-wow-delay="300ms" 
            style="display: block;">`,
            content: (<>
                <p>Enhance workplace productivity with Microsoft 365 Copilot. We help businesses integrate AI-powered assistance into Word, Excel, Outlook, and Teams to streamline content creation, automate workflows, and improve collaboration.</p>
                <p>From deployment to customization, we ensure Microsoft 365 Copilot aligns with your business goals, driving efficiency and intelligent automation across your organization.</p>
                <p>Explore how our innovative solutions have empowered businesses to achieve more. <a href="/work" onClick={() => selectedTechnology()} className="underlineancor">Check out our projects and success stories.</a></p>
            </>),
        },
        {
            heading: (<>Power Platform <br></br>Copilot</>),
            imgSrc: `
            <img class="animation-img-class animation-delay300 disnone img-responsive wow fadeInDown animated fadeinScroll" 
            src="/assets/Images/cloud/poweplatformcopilot.png" alt="database-services" data-wow-duration="1500ms" data-wow-delay="300ms" 
            style="display: block;">`,
            content: (<>
                <p>Empower your organization with AI-driven low-code solutions using Power Platform Copilot. Our services enable businesses to build apps, automate workflows, and gain AI-powered insights with minimal coding effort.</p>
                <p>We provide end-to-end consulting and implementation to help you leverage Power Apps, Power Automate, and Power BI for maximum efficiency and innovation.</p>
                <p>Unlock new possibilities with AI-powered low-code solutions. Discover how Power Platform Copilot transforms business efficiency with streamlined app development and automation workflows. <a href="/work" onClick={() => selectedTechnology()} className="underlineancor">Explore our solutions.</a></p>
            </>),
        },
        {
            heading: (<>Azure AI Studio <br></br>Copilot</>),
            imgSrc: `
            <img class="animation-img-class animation-delay300 disnone img-responsive wow fadeInDown animated fadeinScroll" 
            src="/assets/Images/cloud/AzureAICopilot.png" alt="network-security" data-wow-duration="1500ms" data-wow-delay="300ms" 
            style="display: block;">`,
            content: (<>
                <p>Accelerate AI adoption with Azure AI Studio Copilot. Our team helps businesses build, deploy, and optimize AI models using Azure’s powerful AI tools.</p>
                <p>From model training to seamless deployment, we provide expert guidance to ensure AI solutions drive real business impact and efficiency.</p>
                <p>Discover how we've helped businesses leverage Azure AI Studio Copilot to achieve impactful results. <a href="/work" onClick={() => selectedTechnology()} className="underlineancor">View our work.</a></p>
            </>),
        }
    ];

    const cardsData: CardData[] = [
        {
            heading: 'GitHub Copilot',
            items: [
                'AI-Powered Code Assistance',
                'Accelerated Software Development',
                'Intelligent Debugging & Optimization',
                'Seamless IDE Integration',
                'Collaborative Coding with AI',
            ],
        },
        {
            heading: 'Microsoft 365 Copilot',
            items: [
                'AI-Driven Productivity Enhancement',
                'Smart Document Automation',
                'Intelligent Meeting & Email Summaries',
                'Data Analysis & Insights',
                'Workflow Optimization',
            ],
        },
        {
            heading: 'Power Platform Copilot',
            items: [
                'AI-Assisted App Development',
                'Intelligent Workflow Automation',
                'Data Visualization & Insights',
                'Seamless System Integrations',
                'Security & Compliance Management',
            ],
        },
        {
            heading: 'Azure AI Studio Copilot',
            items: [
                'AI Model Development & Deployment',
                'Machine Learning & Data Analytics',
                'Scalable Cloud AI Solutions',
                'Custom AI-Powered Applications',
                'Intelligent Business Process Automation',
            ],
        }
    ];

    const selectedTechnology = () => {
        sessionStorage.setItem("Selected-Vertical", 'All');
        sessionStorage.setItem("Selected-Technology", 'All');
    }
    const [works, setWorks] = useState<workCaseStudy[]>([]);
    useEffect(() => {
        const keywords = ['copilot','microsoft', 'ai'];
        const additionalKeywords = ['ai', 'artificialintelligence', 'machinelearning', 'automation', 'deeplearning', 'datascience', 'technology', 'microsoft'];
        const results = serviceWorkFilter(workJson.workCaseStudy, keywords, additionalKeywords);
        setWorks(results);
    }, []);
    return (
        <>
            <Box sx={{ padding: 4, textAlign: 'center' }} className="contentbox whitebox ">
                <Container className="innerpagecontainer contentpage">
                    <Typography variant="h2" gutterBottom className='contentwidth to_build'>
                    Redefining Productivity with Microsoft Copilot – AI-Powered Assistance for Smarter Workflows and Innovation</Typography>

                    <Typography variant="body1" sx={{ marginBottom: 2 }} className='contentwidth'>
                    Transform the way you work with Microsoft Copilot. Our intelligent solutions integrate seamlessly across GitHub, Microsoft 365, Power Platform, and Azure AI, enabling smarter automation, real-time insights, and enhanced collaboration for businesses looking to scale efficiently </Typography>

                    <div className='servicesLogo'>
                        <ul>
                            <li><span>
                                <img
                                    src={copilot}
                                    alt="Microsoft Copilot logo"
                                /></span></li>                          

                        </ul>
                    </div>


                </Container>
            </Box>

            <Box className="outerbox powerbitab" sx={{ bgcolor: "#f2c811" }}  >
                <ServiceTabbingSection tabData={tabData} />
            </Box>
            <Box sx={{ padding: 4 }} className="contentbox whitebox contentpage"  >
                <Container className="innerpagecontainer contentpage" >
                    <ServiceCardSection cardsData={cardsData} verticalTitle='Industry-Focused Cloud Excellence – Transforming Key Verticals with Azure & AWS-Powered Innovation' />
                </Container>
            </Box>

            {/* <ServiceCarousel category="azureAWSCloud" /> */}
            {works.length > 0 &&
                <CustomerStories pageName='service' workList={works} />
            }
            <CaseStudyLetsGetStarted projectName='Azure AWS Service' />
            {works.length > 0 ?
                <Footer hasWorkItem={false} /> : <Footer hasWorkItem={true} />
            }
        </>
    );
};

export default MsCopilotSection;